import { render, staticRenderFns } from "./SettingsIndexFieldSelection.vue?vue&type=template&id=9b851508&scoped=true&"
import script from "./SettingsIndexFieldSelection.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexFieldSelection.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIndexFieldSelection.vue?vue&type=style&index=0&id=9b851508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b851508",
  null
  
)

export default component.exports